import Base from '../Base';
import styles from './Layout.module.scss';

const STEP = [
  {
    name: 'email',
    label: 'Confirm Your Email',
  },
  {
    name: 'phone',
    label: 'Confirm Your Phone',
  },
  {
    name: 'profile',
    label: 'Complete Your Profile',
  },
  {
    name: 'socials',
    label: 'Connect Your TikTok',
  },
];

const Layout = ({ children, auth, step }) => {
  return (
    <Base auth={auth}>
      <div className={styles.root}>
        <div className={styles.inner}>

          <ul className={styles.steps}>
            {
              STEP.map((item, i) => (
                <li
                  key={item.name}
                  className={item.name === step ? styles.active : ''}>

                  <span>{i + 1}</span>
                  <span>{item.label}</span>

                </li>
              ))
            }
          </ul>

          <div className={styles.content}>
            {children}
          </div>

        </div>
      </div>
    </Base>
  );
};

export default Layout;